import Cell from "@/components/quote/Cell";
import { fmtD } from "@/lib/format";

/** Sección visible para todos: contenedores + % incremento + total puertas.
 *  Los demás totales de costo solo se muestran a administradores. */
export default function SummaryCard({ summary, importParams, onImport, isAdmin, costTotals }) {
  const s = summary || {};
  const ip = importParams || {};
  const incDisplay = ip.incremento_manual ? Number(ip.incremento_manual) * 100 : (s.incremento_pct || 0);
  const contDisplay = ip.contenedores_manual || s.contenedores || 0;
  const t = costTotals || {};

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4 mb-6">
      <h3 className="font-display font-bold text-slate-900 text-sm uppercase tracking-wide mb-3">Resumen del proyecto</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="bg-slate-50 border border-slate-200 rounded-md px-3 py-2">
          <p className="text-[10px] uppercase tracking-wider text-slate-500">Contenedores (auto)</p>
          <p className="font-mono font-semibold text-slate-900 text-sm mt-0.5">{Number(s.contenedores_auto || 0).toFixed(2)}</p>
        </div>
        <div className="border border-emerald-200 rounded-md px-3 py-1.5 bg-emerald-50/50" title="Número de contenedores usados en el proyecto. Puedes ajustarlo manualmente (redondeo hacia arriba).">
          <p className="text-[10px] uppercase tracking-wider text-emerald-700">Contenedores usados ✎</p>
          <Cell testid="summary-contenedores" value={contDisplay} onChange={(v) => onImport("contenedores_manual", v)} className="text-left" />
        </div>
        <div className="border border-emerald-200 rounded-md px-3 py-1.5 bg-emerald-50/50" title="Porcentaje que se suma al costo FOB por gastos de importación (flete, seguro, impuestos...). Modifica el costo base y por lo tanto el precio de venta. Escribe 0 para volver al cálculo automático.">
          <p className="text-[10px] uppercase tracking-wider text-emerald-700">% Incremento ✎</p>
          <Cell testid="summary-incremento" step={0.1} value={Number(incDisplay).toFixed(2)}
            onChange={(v) => onImport("incremento_manual", (Number(v) || 0) / 100)} className="text-left" />
        </div>
        <div className="bg-slate-50 border border-slate-200 rounded-md px-3 py-2">
          <p className="text-[10px] uppercase tracking-wider text-slate-500">Total de puertas</p>
          <p className="font-mono font-semibold text-slate-900 text-sm mt-0.5" data-testid="summary-total-doors">{s.total_doors || 0}</p>
        </div>
      </div>

      {isAdmin && costTotals && (
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3 mt-3 pt-3 border-t border-slate-100">
          {[["Total FOB", t.total_fob, "total_fob"], ["Flete total", t.flete_total, "flete_total"],
            ["Seguro", t.seguro_total, "seguro_total"], ["Impuestos", t.impuestos, "impuestos"],
            ["Percepción", t.percepcion, "percepcion"], ["SENASA", t.senasa, "senasa"],
            ["Comisión", t.comision, "comision"], ["Inversión total", t.inversion_total, "inversion_total"],
            ["Costo x puerta", t.costo_por_puerta, "costo_por_puerta"]].map(([label, val, key]) => (
            <div key={label} className="bg-amber-50/60 border border-amber-100 rounded-md px-3 py-2">
              <p className="text-[10px] uppercase tracking-wider text-amber-700">{label}</p>
              <p className="font-mono font-semibold text-slate-900 text-sm" data-testid={`cost-${key}`}>{fmtD(val)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
